module.exports = __webpack_public_path__ + "img/pic4_bg.0ecaf61.png";